// Curated, royalty-free imagery for Circularity Global.
// Every URL below was HEAD-validated (200 OK) on 2026-02-17.
// Style: cinematic, photojournalistic, industrial — heimplanet-inspired.

const UNSPLASH = (id, w = 1600, q = 82) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=${q}`;

const PEXELS = (id, w = 1600) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const IMG = {
  // === INDUSTRY / HUBS ===
  industry: {
    factoryLine: UNSPLASH("1581094794329-c8112a89af12"),
    factoryNight: UNSPLASH("1565793298595-6a879b1d9492"),
    portContainers: UNSPLASH("1494412574643-ff11b0a5c1c3"),
    portAerial: UNSPLASH("1493946740644-2d8a1f1a6aff"),
    refineryDusk: UNSPLASH("1504711434969-e33886168f5c"),
    pipesNetwork: UNSPLASH("1581092335397-9583eb92d232"),
    pipesDetail: UNSPLASH("1518391846015-55a9cc003b25"),
    mrfLine: UNSPLASH("1532996122724-e3c354a0b15b"),
    warehouseLights: UNSPLASH("1553413077-190dd305871c"),
    forgeSparks: UNSPLASH("1504309250229-4f08315f3b5c"),
    cleanFactory: UNSPLASH("1611273426858-450d8e3c9fce"),
    industrialDusk: UNSPLASH("1556761175-5973dc0f32e7"),
  },

  // === RESOURCES / FEEDSTOCK ===
  resource: {
    plasticBales: PEXELS("802221"),
    plasticRecycling: UNSPLASH("1583947215259-38e31be8751f"),
    plasticFlakes: UNSPLASH("1611284446314-60a58ac0deb9"),
    biomassPile: UNSPLASH("1574943320219-553eb213f72d"),
    biochar: UNSPLASH("1542838132-92c53300491e"),
    textileBales: PEXELS("3865711"),
    cotton: UNSPLASH("1581090700227-1e37b190418e"),
    solarFarm: UNSPLASH("1509391366360-2e959784a276"),
    solarDesert: UNSPLASH("1466611653911-95081537e5b7"),
    eWaste: UNSPLASH("1605647540924-852290f6b0d5"),
    batteries: UNSPLASH("1620714223084-8fcacc6dfd8d"),
    constructionRubble: UNSPLASH("1545558014-8692077e9b5c"),
    riceField: UNSPLASH("1500382017468-9049fed747ef"),
  },

  // === COMMUNITY / PEOPLE ===
  community: {
    indianWomenSHG: UNSPLASH("1606761568499-6d2451b23c66"),
    workersIndia: UNSPLASH("1606760227091-3dd870d97f1d"),
    workersField: UNSPLASH("1565538810643-b5bdb714032a"),
    recyclerSorting: UNSPLASH("1606811971618-4486d14f3f99"),
    farmlandAerial: UNSPLASH("1492496913980-501348b61469"),
    training: UNSPLASH("1517048676732-d65bc937f952"),
    handshakeField: UNSPLASH("1573164713619-24c711fe7878"),
    researcher: UNSPLASH("1576086213369-97a306d36557"),
  },

  // === LANDSCAPE / GEOGRAPHY ===
  landscape: {
    biomassLand: UNSPLASH("1574943320219-553eb213f72d"),
    droneSite: UNSPLASH("1517520287167-4bbf64a00d66"),
    industrialDusk: UNSPLASH("1556761175-5973dc0f32e7"),
    coastalShipping: UNSPLASH("1494412574643-ff11b0a5c1c3"),
    indianCitySkyline: UNSPLASH("1570168007204-dfb528c6958f"),
    citySkyline: UNSPLASH("1567157577867-05ccb1388e66"),
    desertSolar: UNSPLASH("1466611653911-95081537e5b7"),
    farmlandAerial: UNSPLASH("1492496913980-501348b61469"),
  },

  // === NETWORK / GLOBAL ===
  network: {
    worldNight: UNSPLASH("1451187580459-43490279c0fa"),
    citiesConnect: UNSPLASH("1518770660439-4636190af475"),
    routesMap: UNSPLASH("1524661135-423995f22d0b"),
    cargoShip: UNSPLASH("1494412574643-ff11b0a5c1c3"),
    portAerial: UNSPLASH("1493946740644-2d8a1f1a6aff"),
    aerialGrid: UNSPLASH("1581093588401-fbb62a02f120"),
  },

  // === DATA / INTELLIGENCE ===
  data: {
    chartsDark: UNSPLASH("1611974789855-9c2a0a7236a3"),
    tickerScreen: UNSPLASH("1518186285589-2f7649de83e0"),
    lab: UNSPLASH("1582719471384-894fbb16e074"),
    scientistHands: UNSPLASH("1576086213369-97a306d36557"),
    serverRoom: UNSPLASH("1558494949-ef010cbdcc31"),
  },

  // === HEROES (full-bleed page intros, 1920 wide) ===
  hero: {
    home: UNSPLASH("1670689334799-cdc6777db8cc", 1920),
    about: UNSPLASH("1581094794329-c8112a89af12", 1920),
    network: UNSPLASH("1581093588401-fbb62a02f120", 1920),
    hubs: UNSPLASH("1611273426858-450d8e3c9fce", 1920),
    foundation: UNSPLASH("1606761568499-6d2451b23c66", 1920),
    investors: UNSPLASH("1494412574643-ff11b0a5c1c3", 1920),
    methodology: UNSPLASH("1582719471384-894fbb16e074", 1920),
    networkProof: UNSPLASH("1518770660439-4636190af475", 1920),
    intelligence: UNSPLASH("1611974789855-9c2a0a7236a3", 1920),
    waste2res: UNSPLASH("1532996122724-e3c354a0b15b", 1920),
    atlas: UNSPLASH("1451187580459-43490279c0fa", 1920),
    industrialDusk: UNSPLASH("1556761175-5973dc0f32e7", 1920),
    refinery: UNSPLASH("1504711434969-e33886168f5c", 1920),
  },
};

export default IMG;
